import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import * as auth from './app/auth';
import { environment } from './environments/environment';

const lastExecutedAppVersion = localStorage.getItem('AccessHubApplicationVersion');
const version = environment.version;
if (lastExecutedAppVersion !== version) {
  for (const key of Object.keys(localStorage)) {
    if (key !== 'AccessHubActiveAccount') {
      localStorage.removeItem(key);
    }
  }
  localStorage.setItem('AccessHubApplicationVersion', environment.version);
}

sessionStorage.removeItem('msal.interaction.status');


auth.saveMsalConfig();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
